export default __webpack_public_path__ + "static/media/phantom_user.20072ea3.svg";